import { Box, Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { generateLlmDqRules, validateLlmDqRules } from "../../../api's/LlmDqRulesApi";
import LoadingIcon from '../../../reusable-component/LoadingIcon';
import AddCustomRuleModal2 from './AddCustomRuleModal2';
import AddPredefinedRuleModal from './AddPredefinedRuleModal';
import CustomComponent from './CustomComponent';

function LlmDqRules2({
  disableForm,
  headerName,
  setHeaderName,
  columnName,
  formattedFields,
  setFormattedFields,
  dqRules,
  setDqRules,
  metricList,
}) {
  const [open, setOpen] = useState(false);
  const [openPredefinedRuleModal, setOpenPredefinedRuleModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [loading, setLoading] = useState(0);
  const handleOpenPredefinedRuleModal = () => setOpenPredefinedRuleModal(true);
  const handleClosePredefinedRuleModal = () => setOpenPredefinedRuleModal(false);

  useEffect(() => {
    const newFormattedFields = headerName.map((column) => ({
      fields: [
        {
          fieldName: column.header,
          fieldValues: [column.sampleValue1, column.sampleValue2],
        },
      ],
      target_column: column.header,
    }));
    const prevRuleFailedData = formattedFields.filter(
      (field) => !dqRules.some((rule) => rule.fieldName === field.fieldName && !rule?.isCustomOrPredefined)
    );

    const customOrPredefinedRecords = dqRules.filter((rule) => rule?.isCustomOrPredefined);
    setFormattedFields(newFormattedFields);
    const changes = compareArrays(formattedFields, newFormattedFields);
    console.log('changes: ', changes);
    console.log('dqRules: ', dqRules);
    formattedFields.length === 0 && dqRules.length === 0 && customOrPredefinedRecords.length === 0
      ? handleGeneratingRules(newFormattedFields)
      : prevRuleFailedData.length !== 0
      ? handleGenerateRulesForPrevRuleFailedData(prevRuleFailedData)
      : newFormattedFields.length === formattedFields.length &&
        newFormattedFields.length === changes.common.length &&
        customOrPredefinedRecords.length
      ? console.log(newFormattedFields.length, formattedFields.length, changes.common.length)
      : newFormattedFields.length !== changes.common.length && customOrPredefinedRecords.length > 0
      ? handleGenerateRulesForModifiedOrNewlyAddedorCustomPredefined(changes, customOrPredefinedRecords)
      : newFormattedFields.length !== changes.common.length
      ? handleGenerateRulesForModifiedOrNewlyAdded(changes)
      : changes.removedFieldName.length > 0
      ? (console.log('here: 65 line'),
        setDqRules(
          dqRules.filter((rule) => {
            if (rule.isCustomOrPredefined) return true;
            const fieldName = rule.fields?.[0]?.fieldName;
            return fieldName && !changes.removedFieldName.some((item) => item.fieldName === fieldName);
          })
        ))
      : null;
  }, [headerName]);

  const compareArrays = (arr1, arr2) => {
    console.log('arr1:', arr1);
    console.log('arr2Item:', arr2);
    console.log('compareArrays');

    const changes = {
      added: [],
      removed: [],
      modified: [],
      common: [],
      commonFieldName: [],
      removedFieldName: [],
      addedModified: [],
    };

    arr2?.forEach((el2) => {
      const el1 = arr1?.find((el1) => el1?.fields[0]?.fieldName === el2?.fields[0]?.fieldName);

      if (!el1) {
        changes.added.push(el2);
        changes.addedModified.push(el2);
      } else {
        const el1Values = JSON.stringify(el1.fields[0].fieldValues);
        const el2Values = JSON.stringify(el2.fields[0].fieldValues);

        if (el1Values === el2Values) {
          changes.common.push(el1);
          changes.commonFieldName.push({ fieldName: el2.fields[0].fieldName });
        }
        if (el1Values !== el2Values) {
          changes.modified.push({
            fieldName: el2.fields[0].fieldName,
            fieldValues: el2.fields[0].fieldValues,
          });
          changes.addedModified.push({
            fieldName: el2.fields[0].fieldName,
            fieldValues: el2.fields[0].fieldValues,
          });
        }
      }
    });

    arr1?.forEach((el1) => {
      const el2 = arr2.find((el2) => el2.fields[0].fieldName === el1.fields[0].fieldName);
      if (!el2) {
        changes.removed.push(el1);
        changes.removedFieldName.push({ fieldName: el1.fields[0].fieldName });
      }
    });

    return changes;
  };

  const handleGeneratingRules = async (newFormattedFields) => {
    console.log('handleGeneratingRules');
    const results = [];
    let failedRules = 0;
    setLoading(newFormattedFields.length);

    try {
      const promises = newFormattedFields.map(async (data) => {
        try {
          const response = await generateLlmDqRules(data);
          if (response.status === 200) {
            setLoading((loading) => loading - 1);

            const validationData = {
              udf_code: response.data.udfCode,
              fields: response.data.fields,
              target_column: response.data.target_column,
            };

            const validateResponse = await validateLlmDqRules(validationData);
            if (validateResponse.status === 200) {
              response.data['validationStatus'] = validateResponse.data.success ? 'success' : 'failed';
            }
            results.push(response.data);
          } else {
            setLoading((loading) => loading - 1);
          }
        } catch (error) {
          console.error('Error processing field:', data.fieldName, error);
          setLoading((loading) => loading - 1);
          failedRules++;
        }
      });

      await Promise.all(promises);

      setDqRules(results);
      newFormattedFields.length !== failedRules &&
        enqueueSnackbar('Rules added successfully!', {
          variant: 'success',
        });

      failedRules !== 0 &&
        enqueueSnackbar(`${failedRules} Rule failed!`, {
          variant: 'warning',
        });
    } catch (error) {
      setLoading((loading) => loading - 1);
      enqueueSnackbar('Error while creating rules!', {
        variant: 'error',
    
      });
    } finally {
      setLoading(0);
    }
  };

  const handleGenerateRulesForModifiedOrNewlyAddedorCustomPredefined = async (ruleData) => {
    console.log('handleGenerateRulesForModifiedOrNewlyAddedorCustomPredefined');
    console.log('ruleData: ', ruleData);
    const results = [];
    let failedRules = 0;
    setLoading(ruleData.addedModified.length);
    try {
      const promises = ruleData.addedModified.map(async (data) => {
        try {
          let newData = data;
          if (!data.fields) {
            newData = {
              fields: [data],
              target_column: data.fieldName,
            };
          }

          const response = await generateLlmDqRules(newData);
          if (response.status === 200) {
            setLoading((loading) => loading - 1);

            const validationData = {
              udf_code: response.data.udfCode,
              fields: response.data.fields,
              target_column: response.data.target_column,
            };

            const validateResponse = await validateLlmDqRules(validationData);
            if (validateResponse.status === 200) {
              response.data['validationStatus'] = validateResponse.data.success ? 'success' : 'failed';
            } else {
              response.data['validationStatus'] = 'failed';
            }

            results.push(response.data);

            const filteredRecords = dqRules.filter((rule) =>
              ruleData.commonFieldName.some((common) => common.fieldName === rule.fields[0].fieldName)
            );

            const customOrPredefinedRecords = dqRules.filter(
              (rule) =>
                rule?.isCustomOrPredefined &&
                !filteredRecords.some((filteredRule) => filteredRule.fields[0].fieldName === rule.fields[0].fieldName)
            );

            const combinedResult = [...results, ...filteredRecords, ...customOrPredefinedRecords];
            setDqRules(combinedResult);
          }
        } catch (generateError) {
          console.error('Error generating rule:', generateError);
          setLoading((loading) => loading - 1);
          failedRules++;
        }
      });

      await Promise.all(promises);

      ruleData.addedModified.length !== failedRules &&
        enqueueSnackbar('Rules added successfully!', {
          variant: 'success',
        });

      failedRules !== 0 &&
        enqueueSnackbar(`${failedRules} Rule failed!`, {
          variant: 'warning',
        });
    } catch (error) {
      setLoading((loading) => loading - 1);
      console.error('Unexpected error in handleGenerateRulesForModifiedOrNewlyAddedorCustomPredefined:', error);
    } finally {
      setLoading(0);
    }
  };

  const handleGenerateRulesForModifiedOrNewlyAdded = async (ruleData) => {
    console.log('handleGenerateRulesForModifiedOrNewlyAdded');
    const results = [];
    let failedRules = 0;
    setLoading(ruleData.addedModified.length);
    console.log('ruleData: ', ruleData);
    try {
      const promises = ruleData.addedModified.map(async (data) => {
        try {
          let newData = data;
          if (!data.fields) {
            newData = {
              fields: [data],
              target_column: data.fieldName,
            };
          }
          const response = await generateLlmDqRules(newData);
          if (response.status === 200) {
            setLoading((loading) => loading - 1);
            const validationData = {
              udf_code: response.data.udfCode,
              fields: response.data.fields,
              target_column: response.data.target_column,
            };

            const validateResponse = await validateLlmDqRules(validationData);
            if (validateResponse.status === 200) {
              response.data['validationStatus'] = validateResponse.data.success ? 'success' : 'failed';
            } else {
              response.data['validationStatus'] = 'failed';
            }

            results.push(response.data);

            const filteredRecords = dqRules?.filter((rule) =>
              ruleData.commonFieldName.some((common) => common.fieldName === rule.fields[0].fieldName)
            );
            const customOrPredefinedRecords = dqRules.filter((rule) => rule?.isCustomOrPredefined);
            const combinedResult = [...results, ...filteredRecords, ...customOrPredefinedRecords];
            setDqRules(combinedResult);
          }
        } catch (generateError) {
          setLoading((loading) => loading - 1);
          failedRules++;
          console.error('Error generating rule:', generateError);
        }
      });

      await Promise.all(promises);

      ruleData.addedModified.length !== failedRules &&
        enqueueSnackbar('Rules added successfully!', {
          variant: 'success',
        });

      failedRules !== 0 &&
        enqueueSnackbar(`${failedRules} Rule failed!`, {
          variant: 'warning',
        });
    } catch (error) {
      setLoading((loading) => loading - 1);
      enqueueSnackbar('Error while creating rules!', {
        variant: 'error',
    
      });
      console.error('Unexpected error in rule generation process:', error);
    } finally {
      setLoading(0);
    }
  };

  const handleGenerateRulesForPrevRuleFailedData = async (ruleData) => {
    console.log('handleGenerateRulesForPrevRuleFailedData');
    const results = [];
    let failedRules = 0;
    setLoading(ruleData.length);

    try {
      const promises = ruleData.map(async (data) => {
        try {
          const response = await generateLlmDqRules(data);
          if (response.status === 200) {
            setLoading((loading) => loading - 1);
            const validationData = {
              udf_code: response.data.udfCode,
              fields: response.data.fields,
              target_column: response.data.target_column,
            };

            const validateResponse = await validateLlmDqRules(validationData);
            if (validateResponse.status === 200) {
              response.data['validationStatus'] = validateResponse.data.success ? 'success' : 'failed';
            } else {
              response.data['validationStatus'] = 'failed';
            }

            results.push(response.data);

            const combinedResult = [...results, ...dqRules];
            setDqRules(combinedResult);
          }
        } catch (generateError) {
          setLoading((loading) => loading - 1);
          failedRules++;
          console.error('Error while generating rule:', generateError);
        }
      });

      await Promise.all(promises);

      ruleData.length !== failedRules &&
        enqueueSnackbar('Rules added successfully!', {
          variant: 'success',
        });

      failedRules !== 0 &&
        enqueueSnackbar(`${failedRules} Rule failed!`, {
          variant: 'warning',
        });
    } catch (error) {
      setLoading((loading) => loading - 1);
      enqueueSnackbar('Error while creating rules!', {
        variant: 'error',
    
      });
      console.error('Unexpected error in rule generation process:', error);
    } finally {
      setLoading(0);
    }
  };

  const handleGenerateRulesForEdit = async (ruleData, isCustomOrPredefined, filteredData) => {
    console.log('handleGenerateRulesForEdit');
    const results = [];
    const { udfCode, ...cleanedRuleData } = ruleData;

    const formattedData =
      !cleanedRuleData.dynamicRows || cleanedRuleData.dynamicRows.length === 0
        ? cleanedRuleData
        : {
            fields: cleanedRuleData.dynamicRows.map((row) => ({
              fieldName: row.fieldName,
              fieldValues: [row.firstSampleValue, row.secondSampleValue],
            })),
            target_column:
              cleanedRuleData.dynamicRows.length === 1
                ? cleanedRuleData.dynamicRows[0].fieldName
                : cleanedRuleData.targetColumnName,
            statement: cleanedRuleData.statement,
            metric: cleanedRuleData.metric,
          };
    setLoading(1);
    try {
      console.log('formattedData: ', formattedData);
      const response = await generateLlmDqRules(formattedData);
      let combinedResult = [];

      if (response.status === 200) {
        const validationData = {
          udf_code: response.data.udfCode,
          fields: response.data.fields,
          target_column: response.data.target_column,
        };
        const validateResponse = await validateLlmDqRules(validationData);
        setLoading(0);

        if (validateResponse.status === 200) {
          response.data['validationStatus'] = validateResponse.data.success ? 'success' : 'failed';
          response.data['isCustomOrPredefined'] = isCustomOrPredefined;
        }

        results.push(response.data);

        if (filteredData) {
          const filteredRecords = dqRules?.filter((rule) => rule.fieldId !== ruleData.fieldId);
          combinedResult = [...results, ...filteredRecords];
          enqueueSnackbar('Rule updated successfully!', {
            variant: 'success',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        } else {
          combinedResult = [...results, ...dqRules];
          enqueueSnackbar('Rule added successfully!', {
            variant: 'success',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
          console.log('five');
        }
        setDqRules(combinedResult);
      }
    } catch (error) {
      enqueueSnackbar('500 Internal Server Error!', {
        variant: 'error',
    
      });
      setLoading(0);
      console.error('Error in API call:', error);
    } finally {
      setLoading(0);
    }
  };

  console.log(dqRules);

  return (
    <>
      {dqRules.map((dqRule, index) => (
        <CustomComponent
          index={index}
          dqRule={dqRule}
          key={dqRule.fieldId || index}
          dqRules={dqRules}
          setDqRules={setDqRules}
          handleGenerateRulesForEdit={handleGenerateRulesForEdit}
          formattedFields={formattedFields}
          setFormattedFields={setFormattedFields}
          headerName={headerName}
          setHeaderName={setHeaderName}
          metricList={metricList}
          disableForm={disableForm}
        />
      ))}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Button
          variant="contained"
          sx={{
            display: 'flex',
            marginTop: '8px',
            alignContent: 'flex-start',
            backgroundColor: '#00043C',
            '&:hover': { backgroundColor: '#00043C' },
            marginLeft: '17px',
          }}
          onClick={handleOpen}
          disabled={disableForm}
        >
          Add Custom Rules
        </Button>
        <Button
          variant="contained"
          sx={{
            display: 'flex',
            marginTop: '8px',
            alignContent: 'flex-start',
            backgroundColor: '#00043C',
            '&:hover': { backgroundColor: '#00043C' },
            marginLeft: '17px',
          }}
          onClick={handleOpenPredefinedRuleModal}
          disabled={disableForm}
        >
          Add Predefined Rules
        </Button>
      </div>
      {open && (
        <AddCustomRuleModal2
          open={open}
          handleClose={handleClose}
          metricList={metricList}
          columnName={columnName}
          handleGenerateRulesForEdit={handleGenerateRulesForEdit}
        />
      )}
      {openPredefinedRuleModal && (
        <AddPredefinedRuleModal
          open={openPredefinedRuleModal}
          handleClose={handleClosePredefinedRuleModal}
          metricList={metricList}
          columnName={columnName}
          handleGenerateRulesForEdit={handleGenerateRulesForEdit}
        />
      )}
      {loading !== 0 && <LoadingIcon />}
    </>
  );
}

LlmDqRules2.propTypes = {
  disableForm: PropTypes.bool,
  headerName: PropTypes.array,
};

export default LlmDqRules2;
